export const social = [
  {
    link: "https://laseroctopus.com",
    icon: <i className="bi bi-globe"></i>,
  }
];
